define([
    'handlebars',
    'modules/common/controls/select2',
    'appcontext'
], (Handlebars, Select2, appContext) => {

    function splitVal (string, separator) {
        let val; let i; let l;
        if (string === null || string.length < 1) {
            return [];
        }

        val = string.split(separator);
        for (i = 0, l = val.length; i < l; i = i + 1) {
            val[i] = $.trim(val[i]);
        }

        return val;
    }

    function equal (a, b) {
        if (a === b) {
            return true;
        }
        if (a === undefined || b === undefined) {
            return false;
        }
        if (a === null || b === null) {
            return false;
        }

        /*
         * Check whether 'a' or 'b' is a string (primitive or object).
         * The concatenation of an empty string (+'') converts its argument to a string's primitive.
         */
        if (a.constructor === String) {
            return String(a) === String(b);
        } // a+'' - in case 'a' is a String object
        if (b.constructor === String) {
            return String(b) === String(a);
        } // b+'' - in case 'b' is a String object
        return false;
    }

    return Select2.extend({
        _getChannelId (state) {
            const choice = this.choices.where({name: state.text.toString()});

            return !_.isEmpty(choice) && Boolean(choice[0].get('channel_id')) ? choice[0].get('channel_id') : null;
        },

        formatSelectionCssClass (state) {
            return this._getChannelId(state) ? 'select2-search-choice-image-left' : undefined;
        },

        formatState (state) {
            const channelId = this._getChannelId(state);

            return channelId ? '{0} <span>{1}</span>'.format(
                Handlebars.helpers.h_channel_img(channelId), _.escape(state.text)
            ) : _.escape(state.text);
        },

        initialize () {
            Select2.prototype.initialize.apply(this, arguments);

            const choices = this.choices = this.options.choices;

            if (this.choices) {
                this.listenTo(this.choices, 'reset', this.render);
            }

            _.extend(this.options, {
                tags () {
                    return (choices || []).map((tag) => tag.get('name'));
                },

                initSelection (element, callback) {
                    const data = [];
                    const channels = appContext.channels();
                    const lockSystemLabels = Boolean(this.lockSystemLabels);

                    $(splitVal(element.val(), ',')).each(function () {
                        let obj = {id: this, text: this};
                        let tags = function () {
                            return this.tags;
                        };
                        const channel = channels.where({display_name: this.toString()});

                        obj.locked = lockSystemLabels ? !_.isEmpty(channel) : false;

                        if ($.isFunction(tags)) {
                            tags = tags();
                        }

                        $(tags).each(function () {
                            if (equal(this.id, obj.id)) {
                                obj = this; return false;
                            }
                        });
                        data.push(obj);
                    });

                    callback(data);
                },

                tokenSeparators: [',', ';'],
                choices: null,
                formatNoMatches: this.choices ? _.bind(this.formatNoMatches, this) : null,
                multiple: true,
                allowSelectAll: false
            });
        },

        formatSelection (state) {
            return this.formatState(state);
        },

        formatResult (state) {
            return this.formatState(state);
        },

        matcher (term, text) {
            return text.toUpperCase().indexOf(term.toUpperCase()) >= 0;
        },

        formatNoMatches () {
            return appContext.tr('No matches found');
        },

        render () {
            Select2.prototype.render.apply(this, arguments);

            // this.$el is expected to be already attached to DOM at this moment
            this.$el.select2('destroy').select2(_.clone(this.options));

            return this;
        },

        remove () {
            this.$el.select2('destroy');
            Select2.prototype.remove.apply(this, arguments);
        }

    });

});
